import React, { useEffect, createElement } from 'react';
import { PhoneIcon, CheckCircleIcon } from 'lucide-react';
export const EmergencyForm = () => {
  // Add script to document head
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://online-booking.housecallpro.com/script.js?token=4cb54bae1fdc460f92c54a96d394c01d&orgName=Air-Mazing-Air-LLC';
    script.async = true;
    document.head.appendChild(script);
    return () => {
      // Clean up script when component unmounts
      document.head.removeChild(script);
    };
  }, []);
  return <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-xl p-6 md:p-10 transition-all duration-300 hover:shadow-2xl" data-id="element-117">
      <div className="flex flex-col md:flex-row gap-10" data-id="element-118">
        <div className="md:w-1/2" data-id="element-119">
          <h3 className="text-2xl font-bold text-blue-700 mb-5" data-id="element-120">
            Request Service
          </h3>
          <p className="mb-6 text-gray-600 leading-relaxed" data-id="element-121">
            Fill out this form to schedule service for your HVAC system. Our
            team will respond promptly to address your needs.
          </p>
          <div className="bg-blue-50 p-6 rounded-xl mb-6 border-l-4 border-blue-500" data-id="element-122">
            <h4 className="font-bold text-blue-700 mb-4" data-id="element-123">
              Why choose our service:
            </h4>
            <ul className="space-y-4" data-id="element-124">
              <li className="flex items-start group" data-id="element-125">
                <span className="bg-blue-100 p-1 rounded-full mr-3 mt-0.5 flex-shrink-0 group-hover:bg-blue-200 transition-colors duration-300" data-id="element-126">
                  <CheckCircleIcon className="h-4 w-4 text-blue-600" data-id="element-127" />
                </span>
                <span data-id="element-128">
                  Fast response times, typically within 1-2 hours for
                  emergencies
                </span>
              </li>
              <li className="flex items-start group" data-id="element-129">
                <span className="bg-blue-100 p-1 rounded-full mr-3 mt-0.5 flex-shrink-0 group-hover:bg-blue-200 transition-colors duration-300" data-id="element-130">
                  <CheckCircleIcon className="h-4 w-4 text-blue-600" data-id="element-131" />
                </span>
                <span data-id="element-132">No after-hours upcharges</span>
              </li>
              <li className="flex items-start group" data-id="element-133">
                <span className="bg-blue-100 p-1 rounded-full mr-3 mt-0.5 flex-shrink-0 group-hover:bg-blue-200 transition-colors duration-300" data-id="element-134">
                  <CheckCircleIcon className="h-4 w-4 text-blue-600" data-id="element-135" />
                </span>
                <span data-id="element-136">Fully stocked service vehicles</span>
              </li>
              <li className="flex items-start group" data-id="element-137">
                <span className="bg-blue-100 p-1 rounded-full mr-3 mt-0.5 flex-shrink-0 group-hover:bg-blue-200 transition-colors duration-300" data-id="element-138">
                  <CheckCircleIcon className="h-4 w-4 text-blue-600" data-id="element-139" />
                </span>
                <span data-id="element-140">Transparent pricing with no hidden fees</span>
              </li>
            </ul>
          </div>
          <div className="text-center md:text-left" data-id="element-141">
            <a href="tel:2398886268" className="inline-flex items-center justify-center bg-red-600 hover:bg-red-700 text-white px-6 py-3.5 rounded-md font-bold text-lg transition-all duration-300 shadow-md hover:shadow-lg transform hover:-translate-y-0.5" data-id="element-142">
              <PhoneIcon className="mr-2" data-id="element-143" />
              Call Now: 239-888-6268
            </a>
          </div>
        </div>
        <div className="md:w-1/2" data-id="element-144">
          <iframe id="hcp-lead-iframe" src="https://book.housecallpro.com/lead-form/Air-Mazing-Air-LLC/4cb54bae1fdc460f92c54a96d394c01d" style={{
          border: 'none',
          width: '100%',
          height: '600px'
        }} title="Book a service with Air-Mazing Air" data-id="element-145"></iframe>
        </div>
      </div>
    </div>;
};